import React, { createContext, useContext, useState, useCallback } from "react";

const ThemeContext = createContext();

export const useThemeMode = () => useContext(ThemeContext);

export function ThemeModeProvider({ children }) {
  const [isDark, setIsDark] = useState(
    () => localStorage.getItem("darkMode") === "true"
  );

  const toggleDarkMode = useCallback(() => {
    setIsDark((prev) => {
      const next = !prev;
      localStorage.setItem("darkMode", String(next));
      return next;
    });
  }, []);

  return (
    <ThemeContext.Provider value={{ isDark, toggleDarkMode }}>
      {children}
    </ThemeContext.Provider>
  );
}
